
const testimonialData = [


    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @John Doe",
        image:"https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },

    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @John Doe",
        image:"https://images.pexels.com/photos/1239288/pexels-photo-1239288.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @John Doe",
        image:"https://images.pexels.com/photos/3574678/pexels-photo-3574678.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/3755924/pexels-photo-3755924.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/3756968/pexels-photo-3756968.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/3760741/pexels-photo-3760741.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },

    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Micle Abdull",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"John Doe",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/1520760/pexels-photo-1520760.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },

    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"John Doe",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Profiled",
        username:" @Your Businesss",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Khairul Unima",
        username:" @IndraMaulana",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Alnahda",
        username:" @Alnahada",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"Muhammad Alfikri",
        username:" @muhammadalfikri",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },

    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"John Doe",
        username:" @indramaulana",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
    {
        data:"Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.",
        nama:"John Doe",
        username:" @John Doe",
        image:"https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    },
]

export default testimonialData